import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    flowType: 'default',
    currentStepIndex: 0,
    currentSubstepIndex: 0,
};

const smartDeviceFlowSlice = createSlice({
    name: 'smartDeviceFlow',
    initialState,
    reducers: {
        setSmartDeviceFlowType: (state, action) => {
            const { type, currentStepIndex, currentSubstepIndex } = action.payload;
            state.flowType = type;
            state.currentStepIndex = currentStepIndex || 0;
            state.currentSubstepIndex = currentSubstepIndex || 0;
        },
        setSmartDeviceCurrentStepIndex: (state, action) => {
            state.currentStepIndex = action.payload;
        },
        setSmartDeviceCurrentSubstepIndex: (state, action) => {
            state.currentSubstepIndex = action.payload;
        },
        resetSmartDeviceFlow: (state) => {
            return initialState;
        },
    },
});

export const {
    setSmartDeviceFlowType,
    setSmartDeviceCurrentStepIndex,
    setSmartDeviceCurrentSubstepIndex,
    resetSmartDeviceFlow,
} = smartDeviceFlowSlice.actions;

export const selectSmartDeviceFlowType = (state) => state.smartDeviceFlow.flowType;
export const selectSmartDeviceCurrentStepIndex = (state) => state.smartDeviceFlow.currentStepIndex;
export const selectSmartDeviceCurrentSubstepIndex = (state) => state.smartDeviceFlow.currentSubstepIndex;

export default smartDeviceFlowSlice.reducer;
